import React, { useEffect, useState } from "react";
import DynamicComponent from "../components/dynamic-component";
import { getData, pageIds } from "../config/data";
import Loader from "../components/loader";
import { PageTransition } from "../layouts";
import { scrollToTop } from "../config/functions";

const Home = () => {
  const [data, setData] = useState(null);
  const [pageActive, setPageActive] = useState(false);

  const config = {
    page: pageIds.homepage,
    clear: true,
  };

  useEffect(() => {
    const fetchData = async () => {
      const { result, error } = await getData(config);
      if (error) {
        console.log("Error", error);
      }
      setData(result);
    };
    fetchData();
  }, []);

  useEffect(() => {
    scrollToTop({ behavior: "instant" });
    setTimeout(() => {
      if (data) {
        setPageActive(true);
      }
    }, 150);
  }, [data]);

  if (!data) return <Loader />;

  return (
    <PageTransition className={`${pageActive ? "active" : ""}`}>
      <DynamicComponent listOfComponentsType={data.content} />
    </PageTransition>
  );
};

export default Home;
